module.exports = __webpack_public_path__ + "img/SKMJ_train3.57ac493c.jpg";